import { render, staticRenderFns } from "./feedback_history.vue?vue&type=template&id=453c284c&scoped=true&"
import script from "./feedback_history.vue?vue&type=script&lang=js&"
export * from "./feedback_history.vue?vue&type=script&lang=js&"
import style0 from "./feedback_history.vue?vue&type=style&index=0&lang=less&"
import style1 from "./feedback_history.vue?vue&type=style&index=1&id=453c284c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c284c",
  null
  
)

export default component.exports